/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeneralAttachmentModel } from '../../models/general-attachment-model';

export interface GetPatientInstructionAttachments$Params {
  patientID?: number;
  includeArchived?: boolean;
}

export function GetPatientInstructionAttachments(http: HttpClient, rootUrl: string, params?: GetPatientInstructionAttachments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GeneralAttachmentModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientInstructionAttachments.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('includeArchived', params.includeArchived, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GeneralAttachmentModel>>;
    })
  );
}

GetPatientInstructionAttachments.PATH = '/api/Supervisor/GetPatientInstructionAttachments';
